import { Stack } from "expo-router";
import { OverviewScreenContent } from "@src/features/cameras/screens/OverviewScreenContent";

export default function TenantOverviewScreen() {
  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <OverviewScreenContent />
    </>
  );
}
